import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/countries'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'countries'

export const metadata = {
  icon: 'map',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const CountriesListPage = createListPage({ metadata, api, actionCreators, Content })
const CountriesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { CountriesListPage, CountriesDetailPage }
